import { useTranslation } from 'react-i18next';
import {
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Spinner,
} from '@shared/ui';
import { useCarriersQuery } from '@entities/logistics';

interface CarrierSelectProps {
  value: string | null;
  onChange: (id: string | null) => void;
  fallbackName?: string | null;
}

export function CarrierSelect({ value, onChange, fallbackName }: CarrierSelectProps) {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useCarriersQuery();

  if (isLoading) return <Spinner />;
  if (isError || !data) {
    return (
      <div className="flex flex-col gap-1">
        <Input
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value || null)}
          placeholder={t('shipment.assign.carrier')}
        />
        <p className="text-xs opacity-70">{t('shipment.assign.carrierFallback')}</p>
      </div>
    );
  }

  const selected = data.find((c) => c.id === value);
  return (
    <Select value={value ?? undefined} onValueChange={(v) => onChange(v || null)}>
      <SelectTrigger>
        <SelectValue placeholder={selected?.name ?? fallbackName ?? t('shipment.assign.carrier')} />
      </SelectTrigger>
      <SelectContent>
        {data.map((c) => (
          <SelectItem key={c.id} value={c.id}>
            {c.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
